import styled from '@emotion/styled'
import Icon from '@/components/generics/Icon'

export const ExternalLinkIcon = styled(Icon)`
  margin-right: 2px;
`
